<template>
    <div class="query-page">
        <h1 class="u-m0">
            <span class="u-screenreader">
                Упити
            </span>
        </h1>
        <form @submit.prevent="submit">
            <fieldset class="fieldset">
                <legend class="fieldset-legend">Упити</legend>
                <div class="grid">
                    <div class="grid-cell u-full u-xmed-auto fieldset-item">
                        <label for="query" class="fieldset-label">Изаберите упит</label>
                        <select v-model="selectedQuery" name="" id="query" class="select search-first-field">
                            <option value="1">Број расписаних конкурса</option>
                            <option value="2">Јединице власти које нису расписале конкурс</option>
                            <!-- <option value="3">Укупан број исправних конкурса</option> -->
                            <option value="4">Укупан број пријављених пројеката</option>
                            <option value="5">Укупан број одобрених пројеката</option>
                            <option value="6">Укупна предвиђена средства на конкурсима</option>
                            <option value="7">Укупно додељења средства на конкурсима</option>
                            <!-- <option value="8">Укупна нерасподељена средства на конкурсима</option> -->
                            <option value="9">Највиши додељени износи по пројекту</option>
                            <option value="10">Најнижи додељени износи по пројекту</option>
                            <option value="11">Укупан број примедби на текст конкурса</option>
                            <option value="15">Укупан број примедби на решење о именовању комисије</option>
                            <option value="16">Укупан број примедби на решење о расподели средстава</option>
                            <option value="19">Укупан број именованих чланова комисија по удружењима</option>
                            <!-- <option value="20">Укупан број именованих кандидата из других удружења/медијских стручњака
                            </option> -->
                            <option value="21">Број поништених конкурса</option>
                            <option value="22">Претрага чланова комисије по имену и презимену</option>
                        </select>
                    </div>
                    <div class="grid-cell full-width u-xmed-auto fieldset-item"
                        v-if="appliedQuery === '22' || selectedQuery === '22'">
                        <label for="memberName" class="fieldset-label">Чланови комисија (можете селектовати више
                            вредности)</label>
                        <VueSelect v-model="memberName" label="memberName" id="memberName" :options="members"
                            :reduce="option => option.memberName" :searchable="true"
                            placeholder="Изаберите члана комисије" multiple>
                            <template #no-options>
                                Нема резултата за унету претрагу!
                            </template>
                        </VueSelect>
                    </div>

                    <div v-if="appliedQuery === '22' || selectedQuery === '22'" class="break-row"></div>

                    <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
                        <label for="date-from" class="fieldset-label">Датум од</label>
                        <VueDatePicker v-model="date.from" :minDate="new Date(2015, 0, 1)" :format="'dd.MM.yyyy.'"
                            :enable-time-picker="false" :auto-apply="true" locale="sr" placeholder="Од датума"
                            input-class-name="input" />
                    </div>

                    <div class="grid-cell u-full u-small-1of2 u-xmed-auto fieldset-item">
                        <label for="date-to" class="fieldset-label">Датум до</label>
                        <VueDatePicker v-model="date.to" :minDate="new Date(2015, 0, 1)" :format="'dd.MM.yyyy.'"
                            :enable-time-picker="false" :auto-apply="true" locale="sr" placeholder="До датума"
                            input-class-name="input" />
                    </div>

                    <div class="grid-cell u-full u-xmed-auto fieldset-item fieldset-item--noLabel">
                        <!-- <button type="submit" class="button button--fieldset">Тражи</button> -->
                        <button class="button button--fieldset">Тражи</button>
                    </div>
                </div>
            </fieldset>
        </form>

        <div v-if="loading" class="loading">
            Учитавање...
        </div>

        <div v-else-if="data" class="results">
            <h2 class="h2">Резултати претраге:</h2>

            <div v-if="showTotal" class="total-count">
                <template v-if="appliedQuery === '22'">
                    <strong>Предложен/а: </strong> {{ formatValue(totals.totalCount) }}<br />
                    <!-- <strong> Предложен и именован: </strong> {{ formatValue(totals.bothCount) }} -->
                    <strong> Није изабран/а: </strong> {{ formatValue(totals.suggestedOnlyCount) }}
                    <strong> Изабран/а: </strong> {{ formatValue(totals.chosenOnlyCount) }}
                </template>
                <template v-else-if="appliedQuery === '9'">
                    <strong>Највиши износ по пројекту: </strong> {{ formatValue(data.count) }}
                </template>
                <template v-else-if="appliedQuery === '10'">
                    <strong>Најнижи износ по пројекту: </strong> {{ formatValue(data.count) }}
                </template>
                <template v-else-if="appliedQuery === '21'">
                    <strong>Број поништених конкурса: </strong> {{ formatValue(data.count) }}
                </template>
                <template v-else>
                    <strong>Укупно:</strong> {{ formatValue(data.count) }}
                </template>
            </div>

            <div v-if="(!['11', '15', '16'].includes(appliedQuery) && formattedTableData.length) || (['11', '15', '16'].includes(appliedQuery) && formattedTableData.dataToFormat.length)"
                class="results-table">
                <table>
                    <thead>
                        <template v-if="!['11', '15', '16'].includes(appliedQuery)">
                            <tr>
                                <th v-for="(header, index) in currentTableHeaders" :key="index"
                                    @click="sortTable(index)" style="cursor: pointer;"
                                    :class="[{ 'special-header-column-style': ['19'].includes(appliedQuery) }]">
                                    {{ header }}
                                    <span :class="['sort-indicator', sortKey === index && 'sort-indicator--active']">
                                        {{ sortKey === index ? (sortAsc ? '▲' : '▼') : '↕' }}
                                    </span>
                                </th>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <th v-for="(header, index) in currentTableHeaders" :key="index">
                                    {{ header }}
                                </th>
                            </tr>
                        </template>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in !['11', '15', '16'].includes(appliedQuery) ? formattedTableData : formattedTableData.dataToFormat"
                            :key="item.id != null ? String(item.id) + '_' + String(item.contestId ?? '') + '_' + String(item.memberName ?? '') : index">
                            <!-- Чланови комисије -->
                            <template v-if="appliedQuery === '22'">
                                <td>{{ item.memberNames[0] }}</td>
                                <td>{{ memberStatus(item.chosen, item.suggested) }}</td>
                                <td>{{ item.proposer }}</td>
                                <td>{{ item.calendar }}</td>
                                <td><router-link v-if="item.id"
                                        :to="`/${item.id ? '?jedinica=' + item.id + '#t' : ''}`">
                                        {{ item.townshipName || '-' }}
                                    </router-link></td>
                                <td><router-link v-if="item.contestId"
                                        :to="`/konkurs/${item.contestId}${item.id ? '?jedinica=' + item.id + '#t' : ''}`">
                                        {{ item.competition_name }}
                                    </router-link></td>
                                <td>{{ item.commission }}</td>
                            </template>

                            <!-- Примедбе -->
                            <template v-else-if="['11', '15', '16'].includes(appliedQuery)">
                                <td>{{ item.status }}</td>
                                <td>{{ formatValue(item.value) }}</td>
                            </template>
                            <template v-else-if="appliedQuery === '21'">
                                <td>
                                    <router-link v-if="item.contestId" :to="`/konkurs/${item.contestId}`">
                                        {{ item.name || '-' }}
                                    </router-link>
                                    <span v-else>{{ item.name || '-' }}</span>
                                </td>
                                <td>{{ item.calendar || '—' }}</td>
                            </template>
                            <template v-else-if="['1', '3', '4', '5'].includes(appliedQuery)">
                                <td>
                                    <router-link v-if="item.id" :to="`/?jedinica=${item.id}#t`">
                                        {{ item.name || '-' }}
                                    </router-link>
                                    <span v-else>{{ item.name }}</span>
                                </td>
                                <template v-if="['4', '5'].includes(appliedQuery)">
                                    <td>{{ formatValue(item.projectsTotalCount) }}</td>
                                </template>
                                  <template v-if="['1', '3','5'].includes(appliedQuery)">
                                <td>{{ formatValue(item.count) }}</td>
                                </template>
                                <td>{{ formatMoney(item.total_money) }}</td>
                                <td>{{ formatMoney(item.money_allocated) }}</td>
                                <td>
                                    <div v-for="c in getVisibleContests(item)" :key="c.contestId">
                                        <router-link
                                            :to="`/konkurs/${c.contestId}${item.id ? '?jedinica=' + item.id : ''}#t`">
                                            {{ c.calendar || '-' }}
                                        </router-link>
                                    </div>

                                    <div v-if="item.count > initialVisible">
                                        <button @click="toggleContests(item)" class="show-more-btn">
                                            {{ contestsExpanded[item.id] ? 'Прикажи мање' : `+ ${item.count -
                                                initialVisible} више`
                                            }}
                                        </button>
                                    </div>
                                </td>
                            </template>
                            <template v-else-if="['2'].includes(appliedQuery)">
                                <td>
                                    <router-link v-if="item.id" :to="`/?jedinica=${item.id}#t`">
                                        {{ item.name || '-' }}
                                    </router-link>
                                    <span v-else>{{ item.name }}</span>
                                </td>
                                <td>{{ formatValue(item.count) }}</td>
                                <td>
                                    <div v-for="c in getVisibleNonContests(item)" :key="c.contestId">
                                        <router-link
                                            :to="`/konkurs/${c.contestId}${item.id ? '?jedinica=' + item.id : ''}#t`">
                                            {{ c.calendar ? c.calendar.split('.')[2] : '-' }}
                                        </router-link>
                                    </div>

                                    <div v-if="item.count > initialVisible">
                                        <button @click="toggleNonContests(item)" class="show-more-btn">
                                            {{ nonContestsExpanded[item.id] ? 'Прикажи мање' : `+ ${item.count -
                                                initialVisible} више` }}
                                        </button>
                                    </div>
                                </td>
                            </template>
                            <!-- Подразумевано -->
                            <template v-else>
                                <td>
                                    <!-- Name/Link -->
                                    <template v-if="['19'].includes(appliedQuery)">
                                        {{ item.name || '-' }}
                                    </template>
                                    <template v-else-if="item.id">
                                        <router-link :to="`/?jedinica=${item.id}#t`">{{ item.name || '-'
                                            }}</router-link>
                                    </template>
                                    <template v-else>
                                        <span>{{ item.name }}</span>
                                    </template>
                                </td>
                                <template v-if="appliedQuery === '19'">
                                    <td>{{ formatValue(item.members_count) }}</td>
                                </template>
                                 <template v-else>
                                     <td>{{ formatValue(item.value) }}</td>
                                </template>
                                <td>
                                    <!-- Mode 19: Township Subtable -->
                                    <template v-if="['19'].includes(appliedQuery)">
                                        <table class="sub-table">
                                            <thead>
                                                <tr>
                                                    <th>Јединица</th>
                                                    <th>Број конкурса</th>
                                                    <th>Конкурси</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="t in getVisibleContests(item)" :key="t.township.id"
                                                    class="township-block">
                                                    <td>{{ t.township.name }}</td>
                                                    <td>{{ t.township.township_contests.length }}</td>
                                                    <td class="unit-contests">
                                                        <ul>
                                                            <li v-for="tc in getVisibleTownshipContests(t.township)"
                                                                :key="tc.contestid">
                                                                <router-link
                                                                    :to="`/konkurs/${tc.contestid}?jedinica=${t.township.id}#t`">
                                                                    {{ tc.calendar }}
                                                                </router-link>
                                                            </li>
                                                        </ul>

                                                        <!-- Township More/Less -->
                                                        <button
                                                            v-if="t.township.township_contests.length > initialVisible"
                                                            @click="toggleTownship(t.township)" class="show-more-btn">
                                                            {{ townshipExpanded[t.township.id] ? 'Прикажи мање' : `+
                                                            ${t.township.township_contests.length - initialVisible}
                                                            више` }}
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <!-- Main More/Less for townships -->
                                        <div v-if="item.contests.length > initialVisible">
                                            <button @click="toggleContests(item)" class="show-more-btn">
                                                {{ contestsExpanded[item.id] ? 'Прикажи мање' : `+
                                                ${item.contests.length - initialVisible} више` }}
                                            </button>
                                        </div>
                                    </template>

                                    <!-- Classic Mode -->
                                    <template v-else>
                                        <div v-for="c in getVisibleContests(item)" :key="c.contestid">
                                            <router-link
                                                :to="`/konkurs/${c.contestid}${item.id ? '?jedinica=' + item.id : ''}#t`">
                                                {{ c.calendar || '-' }}
                                            </router-link>
                                        </div>

                                        <!-- Classic More/Less -->
                                        <div v-if="item.count > initialVisible">
                                            <button @click="toggleContests(item)" class="show-more-btn">
                                                {{ contestsExpanded[item.id] ? 'Прикажи мање' : `+ ${item.count -
                                                initialVisible} више` }}
                                            </button>
                                        </div>
                                      
                                            <router-link
                                                :to="`/konkurs/${item.contestId}${item.id ? '?jedinica=' + item.id : ''}#t`">
                                                {{ item.calendar || '-' }}
                                            </router-link>
                    
                                    </template>
                                </td>
                            </template>
                        </tr>
                    </tbody>
                </table>

                <table v-if="['11', '15', '16'].includes(appliedQuery)" style="margin-top: 2rem">
                    <thead>
                        <tr>
                            <th v-for="(header, index) in currentTableHeaders2" :key="index" @click="sortTable(index)"
                                style="cursor: pointer">
                                {{ header }}
                                <span :class="['sort-indicator', sortKey === index && 'sort-indicator--active']">
                                    {{ sortKey === index ? (sortAsc ? '▲' : '▼') : '↕' }}
                                </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in formattedTableData.remarksTable" :key="index">

                            <td>
                                <router-link v-if="item.id" :to="`/?jedinica=${item.id}#t`">
                                    {{ item.name || '-' }}
                                </router-link>
                                <span v-else>{{ item.name }}</span>
                            </td>
                            <td>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Тип примедбе</th>
                                            <th>Број примедби</th>
                                            <th>Конкурси</th>
                                        </tr>
                                    </thead>
                                    <tr v-for="r in item.remarkTypes" :key="r.type" class="remark-type-block">
                                        <td>{{ r.type }}</td>
                                        <td>{{ r.count }}</td>
                                        <td>
                                            <ul>
                                                <li v-for="c in Object.values(r.contests)" :key="c.contestId">
                                                    <router-link :to="`/konkurs/${c.contestId}?jedinica=${item.id}#t`">
                                                        {{ c.contestName }}
                                                    </router-link>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <div v-else-if="(data.count === 0 || !data.count) && (data.total === 0 || !data.total)" class="no-results">
                Нема резултата за задати упит.
            </div>
        </div>
    </div>
</template>

<script src="./Query.js"></script>

<style scoped>
.special-header-column-style {
    width: 33%;
}

.remark-type-block {
    margin-bottom: 1rem;
    border-bottom: 1px solid #eee;
}

.results-table {
    margin-top: 20px;
    overflow-x: auto;
}

table {
    width: 100%;
    border-collapse: collapse;
    background-color: white;
    margin-top: 1rem;
}

th,
td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

th {
    background-color: #f5f5f5;
    font-weight: bold;
}

tr:hover {
    background-color: #f9f9f9;
}

.loading,
.no-results {
    text-align: center;
    padding: 20px;
    color: #666;
}

.total-count {
    margin: 1rem 0;
    font-size: 1.1em;
}

a {
    color: #4CAF50;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}

th.sortable {
    cursor: pointer;
    user-select: none;
}

th.ascending::after {
    content: " ▲";
}

th.descending::after {
    content: " ▼";
}

.break-row {
    flex-basis: 100%;
    height: 1rem;
}

.grid-cell.full-width {
    flex: 1;
    /* take all available space in the row */
    min-width: 0;
    /* prevents overflow issues */
}

.grid-cell.full-width .vue-select,
.grid-cell.full-width .vs__dropdown-toggle {
    width: 100%;
    /* make the select itself full width */
}

/* button.button--fieldset {
    /* your desired styles, for example */
/* padding: 10px 20px;
    font-size: 1rem;
    cursor: pointer;

    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 4px; */
/* } */

.show-more-btn {
    background: none;
    border: none;
    color: var(--csRed);
    cursor: pointer;
    font-weight: 600;
    margin-top: 4px;
    display: inline-block;
    padding: 0;
}

.show-more-btn:hover {
    text-decoration: underline;
}

.v-select.vs--single.vs--searchable {
    line-height: 1;
}
</style>
